import React from 'react'
import Typography from "@material-ui/core/Typography";
import {molabsStyles} from "../styles";
import Grid from "@material-ui/core/Grid";
import Page from "../components/page";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import ContactForm from "../components/contact/contactForm";
import {Paper} from "@material-ui/core";
import Hidden from "@material-ui/core/Hidden";
import {withApollo} from "../client/apollo";
import {useIntl} from "react-intl";

const worldmap = require('../images/contact_worldmap.jpg?size=1216');

function Contact() {
    const classes = molabsStyles();
    const intl = useIntl();
    const image = require('../images/hero1.jpg?resize&sizes[]=1216&sizes[]=960&sizes[]=600&sizes[]=200');
    const webp = require('../images/hero1.jpg?resize&sizes[]=1216&sizes[]=960&sizes[]=600&sizes[]=200&format=webp');

    return (
        <Page
            image={image}
            webp={webp}
            title={intl.formatMessage({id: 'contact_title'})}
            description={intl.formatMessage({id: 'contact_desc'})}
            metaTitle={intl.formatMessage({id: 'contact_title'})}>
            <Grid container className={classes.contactBackground} style={{
                backgroundImage: 'url(' + worldmap.src + ')'
            }}>
                <Hidden smDown>
                    <Grid item md={6}>
                        <Paper elevation={5} classes={{root: classes.contactAddress}}>
                            <Typography color="primary" component="div">
                                <Typography color="textPrimary" component={"h2"}>{intl.formatMessage({id: 'address'})}</Typography>
                                MoLabs Ltd.<br />
                                25 Vitosha Blvd., floor 2<br />
                                Sofia, Bulgaria
                            </Typography>
                            <div>
                                <FontAwesomeIcon fixedWidth icon={['far', 'phone-office']} title={intl.formatMessage({id: 'phone'})} />
                                <a className={classes.link} href={"tel:+35924930255"}> +359 2 493 0255</a>
                            </div>
                            <div>
                                <FontAwesomeIcon fixedWidth icon={['far', 'phone-office']} title={intl.formatMessage({id: 'phone'})} />
                                <a className={classes.link} href={"tel:+4928363469975"}> +49 2836 3469975</a>
                            </div>
                            <div>
                                <FontAwesomeIcon fixedWidth icon={['far', 'envelope']} title={intl.formatMessage({id: 'email'})}/>
                                <a className={classes.link} href={"mailto:contact@molabs.de"}> contact@molabs.de</a>
                            </div>
                        </Paper>
                    </Grid>
                </Hidden>
                <Grid item md={6} sm={12}>
                    <div className={classes.contactForm}>
                        <ContactForm/>
                    </div>
                </Grid>
            </Grid>
        </Page>
    );
}

export default withApollo(Contact);
